export const IDEMPOTENCY_KEY_HEADER = 'Idempotency-Key'

/**
 * One key per human intent, reused across every retry of that intent: the
 * backend collapses a repeat carrying the same key into the original result.
 */
export function newIdempotencyKey(): string {
  // `crypto.randomUUID` is absent outside a secure context.
  const cryptoRef: Crypto | undefined = globalThis.crypto
  if (typeof cryptoRef?.randomUUID === 'function') return cryptoRef.randomUUID()
  return `argus-${String(Date.now())}-${Math.random().toString(36).slice(2, 12)}`
}

export function idempotent(key: string): Readonly<Record<string, string>> {
  return { [IDEMPOTENCY_KEY_HEADER]: key }
}
